export default __webpack_public_path__ + "static/media/Everything_We_Need.454ff857.mp3";